<div class="contenedor2 d-flex">

  <div class=" d-flex">
    <div class="contador">


      <div class="cuadroInfo">
        <h3 class="tex1">HALLOWEEN TALES: DIA DE MUERTOS BY DON JULIO</h3>
        <h4 class="tex2">01 NOVIEMBRE | Callao Calle 11 # 9 - 20</h4>
        <p>{{eventos[0]?.descripcion}}</p>
        <div class="compra"><a routerLink="/eventos/evento/{{eventos[0].id}}">
            <strong>COMPRA TUS TICKETS</strong></a></div>
      </div>

    </div>

    <img src="../../assets/images/img/{{fondo}}" class="fondo-img" alt="">
  </div>